export default __webpack_public_path__ + "static/media/landing-vector.4cb16585.svg";